import type { Environment } from '@shared/environments';
import { createFeatureFlag } from '@shared/featureFlags/featureFlagContextFactory';

export type RestaurantAdminFeatureFlag =
  | 'tieredEvents'
  | 'testFlag'
  | 'reservationTimeline'
  | 'tableCombosCrud'
  | 'eventAddons'
  | 'hideTheListingsPage'
  | 'reservationActivityLog'
  | 'newFloorPlanTableFeatures'
  | 'lightspeedIntegration'
  | 'mlPricing'
  | 'vipProgramCodes'
  | 'vipProgramTiers';

export const featureFlagConfig: Readonly<
  Record<Environment, Record<RestaurantAdminFeatureFlag, boolean>>
> = Object.freeze({
  development: {
    tieredEvents: true,
    testFlag: true,
    reservationTimeline: true,
    tableCombosCrud: true,
    eventAddons: true,
    hideTheListingsPage: true,
    reservationActivityLog: true,
    newFloorPlanTableFeatures: true,
    lightspeedIntegration: true,
    mlPricing: true,
    vipProgramCodes: true,
    vipProgramTiers: true,
  },
  ci: {
    tieredEvents: true,
    testFlag: true,
    reservationTimeline: true,
    tableCombosCrud: true,
    eventAddons: true,
    hideTheListingsPage: true,
    reservationActivityLog: true,
    newFloorPlanTableFeatures: true,
    lightspeedIntegration: true,
    mlPricing: true,
    vipProgramCodes: true,
    vipProgramTiers: true,
  },
  staging: {
    tieredEvents: true,
    testFlag: true,
    reservationTimeline: true,
    tableCombosCrud: true,
    eventAddons: true,
    hideTheListingsPage: true,
    reservationActivityLog: true,
    newFloorPlanTableFeatures: true,
    lightspeedIntegration: true,
    mlPricing: true,
    vipProgramCodes: true,
    vipProgramTiers: true,
  },
  demo: {
    tieredEvents: true,
    testFlag: false,
    reservationTimeline: true,
    tableCombosCrud: true,
    eventAddons: true,
    hideTheListingsPage: true,
    reservationActivityLog: true,
    newFloorPlanTableFeatures: false,
    lightspeedIntegration: false,
    mlPricing: true,
    vipProgramCodes: true,
    vipProgramTiers: true,
  },
  production: {
    tieredEvents: true,
    testFlag: false,
    reservationTimeline: true,
    tableCombosCrud: true,
    eventAddons: true,
    hideTheListingsPage: true,
    reservationActivityLog: true,
    newFloorPlanTableFeatures: true,
    lightspeedIntegration: false,
    mlPricing: true,
    vipProgramCodes: true,
    vipProgramTiers: true,
  },
});

export const {
  Provider: FeatureFlagContextProvider,
  useFeatureFlags: useFeatureFlagContext,
  FeatureFlagContext,
} = createFeatureFlag(featureFlagConfig);
